export default __webpack_public_path__ + "static/Chevron_TCC22_Website_300x250-a2c9255d5ad7b3172745f7ecef6c03b2.jpg";